import { getConversionRates } from "../Components/Profile/Service/ManageClinicUsersService";

export const getFallbackRates = (pharmacyPOS) => ({
	rates: pharmacyPOS?.conversionRates || {},
	baseCurrency: pharmacyPOS?.baseCurrency || "INR",
});

export const mergeRatesIntoPharmacyPOS = (pharmacyPOS, rates, baseCurrency) => {
	if (!pharmacyPOS) return pharmacyPOS;

	return {
		...pharmacyPOS,
		conversionRates: rates,
		...(baseCurrency ? { baseCurrency } : {}),
	};
};

export const persistPharmacyPOS = (pharmacyPOS) => {
	if (!pharmacyPOS) return;
	localStorage.setItem("currentPharmacyPOS", JSON.stringify(pharmacyPOS));
};

/**
 * Fetch latest conversion rates from API.
 * On failure or invalid response, returns rates from pharmacyPOS (cached login profile).
 */
export const fetchConversionRates = async (pharmacyPOS) => {
	const fallback = getFallbackRates(pharmacyPOS);

	try {
		const response = await getConversionRates();
		const payload = response?.data;

		if (payload?.status === "success" && payload?.data?.rates) {
			const rates = payload.data.rates;
			const baseCurrency =
				payload.data.baseCurrency || fallback.baseCurrency;

			if (typeof rates === "object" && Object.keys(rates).length > 0) {
				return {
					success: true,
					rates,
					baseCurrency,
				};
			}
		}
	} catch {
		// Fall through to cached pharmacyPOS rates.
	}

	return {
		success: false,
		rates: fallback.rates,
		baseCurrency: fallback.baseCurrency,
	};
};
